/**
 * A lending application's `product` is serialized as the full product object at
 * runtime, but the generated API types declare it as a string. The UUID field
 * also differs by product family: credit card exposes `id`, while personal and
 * auto loans expose `uuid`. Normalize all of these shapes to the product UUID
 * (or `undefined` when it cannot be determined).
 */
export function getProductUuid(
  product: { id?: string; uuid?: string } | string | null | undefined
): string | undefined {
  if (typeof product === "string") {
    return product || undefined;
  }
  return product?.id ?? product?.uuid ?? undefined;
}
